console.log('[Fee] personalisation-fee.js loaded');

(function () {
  // Fee product: "Personalisation Fee" in Shopify Admin > Products (Active, Online Store channel).
  // To update fee amount: change the price of that product in admin.
  // To update variant ID: Admin > Products > Personalisation Fee > Default variant > copy ID from URL.
  var PERSONALISATION_FEE_VARIANT_ID = 52497070162201;
  var originalFetch = window.fetch;
  var syncingFee = false;

  // Local cart snapshot -- used to identify which item is being removed before it disappears
  var lastKnownCart = { items: [] };

  function refreshCartSnapshot() {
    originalFetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { lastKnownCart = cart; })
      .catch(function () {});
  }

  refreshCartSnapshot();

  window.fetch = function (url, options) {

    // --- Add fee when personalised product is added ---
    if (typeof url === 'string' && url.indexOf('/cart/add') !== -1) {
      try {
        var body = options && options.body;
        var personalisationValue = null;
        var mainItem = null;

        if (body instanceof FormData) {
          personalisationValue = body.get('properties[Customised Name]');
          if (personalisationValue && personalisationValue.trim()) {
            mainItem = {
              id: parseInt(body.get('id')),
              quantity: parseInt(body.get('quantity')) || 1,
              properties: { 'Customised Name': personalisationValue.trim() }
            };
          }
        } else if (typeof body === 'string') {
          var parsed = JSON.parse(body);
          personalisationValue = parsed.properties && parsed.properties['Customised Name'];
          if (personalisationValue && personalisationValue.trim()) {
            mainItem = { id: parsed.id, quantity: parsed.quantity || 1, properties: parsed.properties };
          }
        }

        if (mainItem) {
          console.log('[Fee] Bundling fee into cart add request');
          var modifiedOptions = Object.assign({}, options, {
            headers: Object.assign({}, options.headers, { 'Content-Type': 'application/json' }),
            body: JSON.stringify({
              items: [
                { id: PERSONALISATION_FEE_VARIANT_ID, quantity: 1, properties: { 'Name': personalisationValue.trim() } },
                mainItem
              ]
            })
          });
          var addResult = originalFetch.call(this, url, modifiedOptions);
          addResult.then(refreshCartSnapshot);
          return addResult;
        }
      } catch (e) {
        console.warn('[Fee] Could not modify add request:', e);
      }
    }

    var result = originalFetch.apply(this, arguments);

    // --- Sync paired item removal on cart/change ---
    if (typeof url === 'string' && url.indexOf('/cart/change') !== -1 && !syncingFee) {
      // Capture which item is being removed BEFORE the response comes back
      var removedItem = getItemBeingRemoved(options, lastKnownCart);

      result.then(function () {
        refreshCartSnapshot();
        if (removedItem) {
          setTimeout(function () { removePairedItem(removedItem); }, 400);
        }
      });
    }

    if (typeof url === 'string' && url.indexOf('/cart/update') !== -1) {
      result.then(refreshCartSnapshot);
    }

    return result;
  };

  // Identifies which cart item is being removed from the change request body
  function getItemBeingRemoved(options, cart) {
    if (!cart || !cart.items || !options) return null;
    try {
      var changeData = typeof options.body === 'string' ? JSON.parse(options.body) : null;
      if (!changeData || changeData.quantity !== 0) return null;

      if (changeData.line) {
        return cart.items[parseInt(changeData.line) - 1] || null;
      }
      if (changeData.id) {
        return cart.items.find(function (i) {
          return i.key === changeData.id || String(i.variant_id) === String(changeData.id);
        }) || null;
      }
    } catch (e) {}
    return null;
  }

  // Removes the item paired with the one that was just deleted, matched by name
  function removePairedItem(removedItem) {
    if (syncingFee) return;

    if (removedItem.variant_id === PERSONALISATION_FEE_VARIANT_ID) {
      // Fee removed → remove the specific personalised product with matching name
      var feeName = removedItem.properties && removedItem.properties['Name'];
      if (!feeName) return;
      console.log('[Fee] Fee removed, removing personalised product for:', feeName);
      removeCartItemByProperty('Customised Name', feeName.trim());

    } else if (removedItem.properties && removedItem.properties['Customised Name']) {
      // Personalised product removed → remove the specific fee with matching name
      var customName = removedItem.properties['Customised Name'];
      console.log('[Fee] Product removed, removing fee for:', customName);
      removeCartItemByProperty('Name', customName.trim(), PERSONALISATION_FEE_VARIANT_ID);
    }
  }

  // Removes a cart item by matching a property value, optionally also filtering by variant ID
  function removeCartItemByProperty(propKey, propValue, variantIdFilter) {
    var matchingItem = lastKnownCart.items.find(function (item) {
      var propMatch = item.properties && item.properties[propKey] === propValue;
      var variantMatch = variantIdFilter ? item.variant_id === variantIdFilter : true;
      return propMatch && variantMatch;
    });

    if (!matchingItem) return;
    syncingFee = true;

    var domRemoved = tryRemoveDOMItemByProperty(propKey, propValue);
    if (!domRemoved) {
      originalFetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: matchingItem.key, quantity: 0 })
      }).then(function () {
        refreshCartSnapshot();
        syncingFee = false;
      }).catch(function () { syncingFee = false; });
    } else {
      setTimeout(function () { refreshCartSnapshot(); syncingFee = false; }, 2000);
    }
  }

  // Clicks the theme's remove button for the cart row matching a specific property key/value
  function tryRemoveDOMItemByProperty(propKey, propValue) {
    var rows = document.querySelectorAll('.cart-items__table-row');
    for (var i = 0; i < rows.length; i++) {
      var dts = rows[i].querySelectorAll('.cart-items__property dt');
      for (var j = 0; j < dts.length; j++) {
        var dtText = dts[j].textContent.replace(':', '').trim();
        var dd = dts[j].nextElementSibling;
        var ddText = dd ? dd.textContent.trim() : '';
        if (dtText === propKey && ddText === propValue) {
          var btn = rows[i].querySelector('.cart-items__remove');
          if (btn) {
            btn.click();
            console.log('[Fee] Removed via DOM -- ' + propKey + ': ' + propValue);
            return true;
          }
        }
      }
    }
    return false;
  }

})();